import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const mhStackVariants = cva('flex', {
  variants: {
    direction: {
      vertical: 'flex-col',
      horizontal: 'flex-row',
    },
    gap: {
      8: 'gap-2',
      12: 'gap-3',
      16: 'gap-4',
      24: 'gap-6',
      32: 'gap-8',
      48: 'gap-12',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    wrap: {
      none: 'flex-nowrap',
      wrap: 'flex-wrap',
      reverse: 'flex-wrap-reverse',
    },
  },
  defaultVariants: {
    direction: 'vertical',
    gap: 16,
    align: 'stretch',
    justify: 'start',
    wrap: 'none',
  },
});

export interface MHStackProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof mhStackVariants> {}

const MHStack = React.forwardRef<HTMLDivElement, MHStackProps>(
  ({ className, direction, gap, align, justify, wrap, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        mhStackVariants({ direction, gap, align, justify, wrap }),
        className
      )}
      {...props}
    />
  )
);

MHStack.displayName = 'MHStack';

export { MHStack, mhStackVariants };
